import { useLocation, Link } from "react-router-dom";
import { Breadcrumbs as MUIBreadcumbs, Typography } from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const Breadcrumbs = () => {
    const location = useLocation();
    const pathname = location.pathname.replace(/\/\s*$/, '');
    const paths = pathname.split('/');
    let link = '';
    const crumbs = paths.map((path, i) => {
        link += `${path}/`;

        if (i + 1 === paths.length) {
            return (
                <Typography key={path}>{path}</Typography>
            );
        }
        return (
            <Link key={path} to={link}>{path ? path : 'Home'}</Link>
        );
    });
    return (
        <MUIBreadcumbs
            aria-label="Breadcrumbs"
            separator={<NavigateNextIcon fontSize="small" />}
            sx={{
                padding: crumbs?.length > 1 ? '0px 16px 16px 16px' : 0
            }}
        >
            {crumbs}
        </MUIBreadcumbs>
    );
}

export default Breadcrumbs;